import axiosClient  from "./../Network/apiClient"

const ProjectService = {
    getSettings: (project) => {
        const projectId = project || parseInt(process.env.REACT_APP_PROJECTID)
        return axiosClient.get(`/projects/${projectId}/settings`);
    },
    get: () => {
        return axiosClient.get('/projects');
    }
}

export default ProjectService
